import { useState, useEffect } from 'react';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const featureFlagDefinitions: { key: FeatureFlagKeys; label: string; description: string }[] = [
  { key: 'vbShop', label: 'VB Shop', description: 'Group policy funding page' },
  { key: 'ltciPartners', label: 'LTCI Partners', description: 'LTCI Partners disclaimers' },
  { key: 'agis', label: 'AGIS', description: 'AGIS group policy funding page' },
  {
    key: 'quoteApplyLincolnFinancial',
    label: 'Quote Apply Lincoln Financial',
    description: 'Quote Apply Lincoln Financial',
  },
  {
    key: 'hideSinglePayAnd10Pay',
    label: 'Hide Single Pay and 10-Pay',
    description: 'Hide Single Pay and 10-Pay payment options in Shop Insurance filters',
  },
];

interface FeatureFlagsEditorProps {
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
}

export function FeatureFlagsEditor({ value, onChange, error }: FeatureFlagsEditorProps) {
  const [flags, setFlags] = useState<FeatureFlags>({});

  useEffect(() => {
    try {
      const parsed = value ? JSON.parse(value) : {};
      setFlags(parsed);
    } catch {
      setFlags({});
    }
  }, [value]);

  const handleToggle = (key: FeatureFlagKeys) => {
    const newFlags = { ...flags, [key]: !flags[key] };
    setFlags(newFlags);
    onChange(JSON.stringify(newFlags));
  };

  return (
    <Card className={cn('space-y-4 p-4', error && 'border-red-500')}>
      <div className="space-y-3">
        {featureFlagDefinitions.map(({ key, label, description }) => (
          <div
            key={key}
            className="flex items-center justify-between space-x-3"
          >
            <div className="flex-1">
              <Label
                htmlFor={key}
                className="text-sm font-medium"
              >
                {label}
              </Label>
              <p className="text-xs text-gray-500">{description}</p>
            </div>
            <Switch
              id={key}
              checked={!!flags[key]}
              onCheckedChange={() => handleToggle(key)}
            />
          </div>
        ))}
      </div>
    </Card>
  );
}
